import axios, { AxiosRequestConfig, Method } from 'axios';
import { ApiResponse } from '../Common/Models/APIResponse';
import { MessageBase } from 'Common/Components/Messages/messageBase';
import { NotificationBase } from 'Common/Components/Notifications/notificationBase';
import { uuid as uuidv4 } from 'uuidv4';
import { MessageType } from 'Common/Components/Messages/messageTypes';
import Cookies from 'js-cookie';

export async function axios_helper_async<T>(
    url: string,
    method: Method = 'GET',
    body: any = null,
    options: AxiosRequestConfig | null = null
): Promise<ApiResponse<T>> {
    try {
        let urlBase = window.location.origin
        //let urlBase = process.env.REACT_APP_API_URL;
        //let urlBase = window.location.origin;
        const config: AxiosRequestConfig = {
            method,
            url: `${urlBase}${url}`,
            headers: { 'Content-Type': 'application/json', ...(options?.headers || {}) },
            data: method !== 'GET' && method !== 'DELETE' && method !== 'OPTIONS' && method !== 'HEAD' ? body : null,
            params: method === 'GET' || method === 'DELETE' || method === 'OPTIONS' || method === 'HEAD' ? body : null,
            ...options,
        };

        config.httpsAgent = { rejectUnauthorized: false };
        const token = Cookies.get('authSOIToken');
        
        if (token) {
            if(config.headers)
            {
                config.headers.Authorization = `Bearer ${token}`;  
            }
        }
        const response = await axios(config);
        
        let messages: Array<MessageBase> = JSON.parse(response.headers['messages'] ?? '[]');
        let notifications: Array<NotificationBase> = JSON.parse(response.headers['notifications'] ?? '[]');
        
        return {
            data: response.data as T,            
            isSuccess: true,
            notifications: notifications,
            messages: messages
        };
    } catch (error: any) {
        let messages: Array<MessageBase> = [];
        let notifications: Array<NotificationBase> = [];
        if(error.response && error.response.headers){            
            messages = JSON.parse(error.response.headers['messages'] ?? '[]');
            notifications = JSON.parse(error.response.headers['notifications'] ?? '[]');
        }
        if(error.response && error.response.status && error.response.status === 401) {
            messages.push({id: uuidv4(), message: "No tienes acceso a esta sección", title: "Autorización", type: MessageType.Error})
        }
        else if (error.response && error.response.data && error.response.data.errors) {
            const { errors } = error.response.data;
            let _messages = '';
            Object.keys(errors).forEach((key) => {
                if(_messages) _messages += ' / ';
                _messages += `${errors[key].join(", ")}`;
            });
            messages.push({id: uuidv4(), message: _messages, title: error.message, type: MessageType.Error})
        }
        else if (error.response && error.response.data && error.response.data !== '' && error.response.data !== null) {
            messages.push({id: uuidv4(), message: error.response.data, title: error.message, type: MessageType.Error})
        }
        else if(error.message) {
            messages.push({id: uuidv4(), message: error.message, title: 'Error al intentar enviar la información al servidor', type: MessageType.Error}) //
        }

        return {
            data: null,
            isSuccess: false,
            notifications: notifications,
            messages: messages
        };
    }
}

// import axios, { AxiosRequestConfig, Method } from 'axios';
// import i18n from "i18next";
// import { ApiResponse } from './APIResponse';

// export async function axios_helper_async<T>(
//     url: string,
//     method: Method = 'GET',
//     body: any = null,
//     errorTitle: string | null = null,
//     errorMsg: string | null = null,
//     options: AxiosRequestConfig | null = null
// ): Promise<ApiResponse<T>> {
//     try {
//         // console.log(body)
//         const config: AxiosRequestConfig = {
//             method,
//             url: `${process.env.REACT_APP_API_URL}${url}`,
//             headers: { 'Content-Type': 'application/json', ...(options?.headers || {}) },
//             data: method !== 'GET' ? body : null,
//             params: method === 'GET' ? body : null,
//             ...options,
//         };

//         const response = await axios(config);

//         return {
//             data: response.data as T,
//             message: '',
//             isSuccess: true,
//         };
//     } catch (error: any) {
//         let message = i18n.t('AxiosAPI.UnexpectedError');

//         if (error.response && error.response.data) {
//             message = error.response.data.message || error.response.data ||  i18n.t('AxiosAPI.NoneMessage');
//         } else if (error.request) {
//             message = i18n.t('AxiosAPI.NoneResponse');
//         } else if (error.message) {
//             message = error.message;
//         }

//         return {
//             data: null,
//             message: message,
//             isSuccess: false,
//         };
//     }
// }
